import { gql } from '@apollo/client';

const insurance = gql`
  fragment CompleteInsurance on Insurance {
    price
    passenger {
      firstName
      lastName
    }
    currency
    date
    policyNumber
    description
    cancelled
    provisional
    itemRef
  }
`;

export default insurance;
